(function ($) {

 //display header on scrolltop only if after hero image
    var scroll_pos = 0;
    var scroll_time;

    $(window).scroll(function() {
        clearTimeout(scroll_time);
        var current_scroll = $(window).scrollTop();

        var main_coord = $('#main').offset();

        if (current_scroll >= $('header').outerHeight()) {

            if(current_scroll > main_coord.top && current_scroll <= scroll_pos) {
                $('header').addClass('sticky');
                $('#main').css('padding-top', '118px');
            }
            
            else {
                $('header').removeClass('sticky');
                $('#main').css('padding-top', '0');
            }
        }
            
        scroll_time = setTimeout(function() {
            scroll_pos = $(window).scrollTop();
        }, 100);
    });

    $(document).ready(function() {
        var video = document.getElementById("bgVideo");
        video.oncanplaythrough = function() {
            video.muted = true;
            video.play();
        }
    })

    var idModal = "";

    function autoplayVideo() {
        if($('#js-modal-content iframe').length) {
            var str = $('#js-modal-content iframe').attr('src');
            $('#js-modal-content iframe').attr('src', str.replace("autoplay=0", "autoplay=1"));
        }
    }

    function stopVideo() {
        if($('#js-modal-content iframe').length) {
            var strModal = $('#js-modal-content iframe').attr('src');
            
            $('#js-modal-content iframe').attr('src', strModal.replace("autoplay=1", "autoplay=0"));
            
        }
    }
    
    // autoplay / stop video if dialog is opened / closed
    
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {

            if (mutation.addedNodes && mutation.addedNodes.length > 0 && mutation.addedNodes[0].className === 'simple-modal') {
                autoplayVideo();
                idModal = $('#js-modal-close').data('content-back-id');
            }

            if(mutation.removedNodes && mutation.removedNodes.length > 0 && mutation.removedNodes[0].className === 'simple-modal') {
                stopVideo();
                var str = $('#'+idModal+' iframe').attr('src');
                $('#'+idModal+' iframe').attr('src', str.replace("autoplay=1", "autoplay=0"));
            }
        });
    });


    var config = {
        attributes: true,
        childList: true,
        characterData: true
    };

observer.observe(document.body, config);

})(jQuery);